export default {
  default: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/layouts/default.vue").then(m => m.default || m),
  limpo: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/layouts/limpo.vue").then(m => m.default || m),
  msmax: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/layouts/msmax.vue").then(m => m.default || m),
  ooloja: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/layouts/ooloja.vue").then(m => m.default || m),
  topo: () => import("/home/firethewall/MSBNET/projeto_OO/OO-Administrador/layouts/topo.vue").then(m => m.default || m)
}